import * as bookingActions from "./booking.action";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  bookings: [
    {
      bookingId: uuidv4(),
      bookingRate: "",
      bookingAmount: "",
      pureWeight: "",
    },
  ],
  avgBookingDetails: {
    averageRate: 5420,
    averageAmount: 5000000,
    averagePureWeight: 1000,
  },
};

export const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case bookingActions.CREATE_BOOKING:
      return {
        ...state,
        bookings: [
          ...state.bookings,
          {
            bookingId: uuidv4(),
            bookingRate: "",
            bookingAmount: "",
            pureWeight: "",
          },
        ],
      };
    case bookingActions.UPDATE_BOOKING:
      return {
        ...state,
        bookings: action.payload,
      };
    case bookingActions.DELETE_BOOKING:
      return {
        ...state,
        bookings: state.bookings.filter(
          (item) => item.bookingId !== action.payload
        ),
      };
    case bookingActions.AVGBOOKINGS_BOOKING:
      return {
        ...state,
        avgBookingDetails: action.payload,
      };
    default:
      return { ...state };
  }
};
